import { render, staticRenderFns } from "./CollectorIntegration.vue?vue&type=template&id=1a7b7669&scoped=true&"
import script from "./CollectorIntegration.vue?vue&type=script&lang=js&"
export * from "./CollectorIntegration.vue?vue&type=script&lang=js&"
import style0 from "./CollectorIntegration.vue?vue&type=style&index=0&id=1a7b7669&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b7669",
  null
  
)

export default component.exports